import { render, staticRenderFns } from "./TelegramMenus.vue?vue&type=template&id=78160178&scoped=true"
import script from "./TelegramMenus.vue?vue&type=script&lang=js"
export * from "./TelegramMenus.vue?vue&type=script&lang=js"
import style0 from "./TelegramMenus.vue?vue&type=style&index=0&id=78160178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78160178",
  null
  
)

export default component.exports